import { useState, useCallback } from 'react';

export const useDarkMode = () => {
  const [darkMode, setDarkMode] = useState(() => {
    try {
      const saved = localStorage.getItem('darkMode');
      return saved ? JSON.parse(saved) : false;
    } catch (e) {
      return false;
    }
  });

  const toggleDarkMode = useCallback(() => {
    setDarkMode(prev => {
      const newMode = !prev;
      try {
        localStorage.setItem('darkMode', JSON.stringify(newMode));
      } catch (e) {
        console.warn('Could not save dark mode preference:', e);
      }
      return newMode;
    });
  }, []);

  return {
    darkMode,
    toggleDarkMode
  };
};